import QRCode from "react-qr-code";

import { Row } from "@components/Flex";
import { Spacing, SpacingSizes } from "@components/Spacing";
import { Body, H1 } from "@components/Typography";
import { environment } from "@config";
import { useWindowDimensions } from "@hooks";
import { Translations, i18n } from "@i18n";
import { AppleStore } from "./AppleStore";
import { GooglePlay } from "./GooglePlay";
import { useStyles } from "./styles";

const QR_CODE_LINK = "https://get.futuremoney.co/d5ij/download";

const TAB_BAR_OFFSET = 102;

export const DownloadAppPlaceholder = () => {
  const styles = useStyles();

  const { width } = useWindowDimensions();

  const onGooglePlayClick = () => {
    window.open(environment.store.google, "_blank");
  };

  const onAppleClick = () => {
    window.open(environment.store.apple, "_blank");
  };

  return (
    <div
      style={{
        ...styles.wrapper,
        paddingBottom: width < 700 ? TAB_BAR_OFFSET : 0,
      }}
    >
      <div style={styles.container}>
        <Spacing size={SpacingSizes.M} />

        {width > 600 ? (
          <>
            <div style={styles.qr}>
              <QRCode value={QR_CODE_LINK} />
            </div>
            <Spacing size={SpacingSizes.XL} />
          </>
        ) : null}

        <H1 style={styles.text}>{i18n.t(Translations.DownloadAppPlaceholderTitle)}</H1>
        <Spacing size={SpacingSizes.XL} />

        <Body style={styles.text}>{i18n.t(Translations.DownloadAppPlaceholderSubtitle)}</Body>
        <Spacing size={SpacingSizes.XL} />

        <Row style={styles.footer}>
          <div style={styles.footerInner}>
            <div onClick={onGooglePlayClick} style={styles.store}>
              <GooglePlay />
            </div>
            <div onClick={onAppleClick} style={styles.store}>
              <AppleStore />
            </div>
          </div>
        </Row>
      </div>
    </div>
  );
};
